import { CourseApi } from "@thepiquelab/web-api";
import { FeatureAccess } from "@thepiquelab/web-types";
import { useRequest } from "ahooks";
import { useEffect, useRef } from "react";

export const usePostFeatureDataSubscription = (): {
  enabledFeatureData: FeatureAccess[];
  enabledFeatureDataLoading: boolean;
  refreshEnabledFeatureData: () => void;
} => {
  const hasLoadedOnceRef = useRef(false);
  const {
    data: originalEnabledFeatureData,
    loading: getEnabledFeatureDataLoading,
    refresh: refreshEnabledFeatureData,
  } = useRequest(() => CourseApi.getEnabledFeatureAccesses(), {
    cacheKey: "enabled-features",
    onSuccess: () => {
      if (!hasLoadedOnceRef.current) {
        hasLoadedOnceRef.current = true;
      }
    },
    onError: () => {
      if (!hasLoadedOnceRef.current) {
        hasLoadedOnceRef.current = true;
      }
    },
  });

  useEffect(() => {
    if (!hasLoadedOnceRef.current && originalEnabledFeatureData !== undefined) {
      hasLoadedOnceRef.current = true;
    }
  }, [originalEnabledFeatureData]);

  return {
    enabledFeatureData: originalEnabledFeatureData || [],
    enabledFeatureDataLoading:
      !hasLoadedOnceRef.current && getEnabledFeatureDataLoading,
    refreshEnabledFeatureData,
  };
};
